import dayjs from 'dayjs'

const formatDateRange = (startString, endString) => {
  const start = dayjs(startString);
  const end = dayjs(endString);
  
  // Same Date
  if (start.isSame(end, 'day')) {
    return start.format('DD MMM YYYY');
  }
    
  // Same Month
  if (start.isSame(end, 'month')) {
    return `${start.format('D')} - ${end.format('D')} ${start.format('MMM YYYY')}`;
  }
  
  // Same Year
  if (start.isSame(end, 'year')) {
    return `${start.format('D MMM')} - ${end.format('D MMM')} ${start.format('YYYY')}`;
  }
  
  return `${start.format('D MMM YYYY')} - ${end.format('D MMM YYYY')}`;
}


export { formatDateRange };



// WEBPACK FOOTER //
// ./src/utils/formatDate.js